/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import { Box, Stack, Typography } from "@mui/material";
import AccordionGroupProvider from "@/src/components/Accordion/AccordionGroupProvider";
import { ourValuesAccordions } from "@/src/components/Sections/Generic/OurValues/ourValuesContent";
import Accordion from "@/src/components/Accordion/Accordion";
import titleImage from "@/src/assets/img/ourValues/titleImage.webp";
import { ourValuesStyle } from "@/src/components/Sections/Generic/OurValues/ourValuesStyle";
import Section from "@/src/components/Section/Section";

export default function OurValues() {
  return (
    <Section>
      <Container
        variant={"lg"}
        sx={(theme) => ({
          paddingTop: "2rem",
          [theme.breakpoints.up("md")]: {
            paddingTop: "5rem",
          },
        })}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 5 }}>
            <Typography variant={"h1"} sx={{ margin: 0 }}>
              Wir finden die beste Lösung für Ihr Problem.
            </Typography>
            <Box component={"img"} src={titleImage} width={1086} height={1086} alt={""} sx={ourValuesStyle.image} />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }} offset={{ xs: 0, md: 2 }}>
            <Stack spacing={4}>
              <Typography>
                <strong>
                  Bei uns kommen Sie seit 2018 sicher und zuverlässig ans Ziel - egal, wie klein oder groß Ihr rechtliches Problem zu sein scheint.
                </strong>{" "}
                Wir kümmern uns persönlich um Ihr Anliegen und verbinden jahrzehntelange Erfahrung mit moderner Technologie. So wird Recht für Sie klar,
                zugänglich und unkompliziert.
              </Typography>
              <Typography>
                Unsere Werte sind die Basis für jede unserer Entscheidungen und stellen sicher, dass wir jederzeit erfolgreiche Ergebnisse für Sie erzielen
                können.
              </Typography>
              <Box>
                <AccordionGroupProvider>
                  {ourValuesAccordions.map((accordion) => (
                    <Accordion key={accordion.id} titlePrefix={accordion.id} title={accordion.title} variant={"text"}>
                      <Typography>{accordion.description}</Typography>
                    </Accordion>
                  ))}
                </AccordionGroupProvider>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}
